import { Component, Input, OnInit, DoCheck, OnChanges } from '@angular/core';

@Component({
  selector: 'app-star-comonent',
  templateUrl: 'star-component.html',
  styleUrls: ['star-component.css']
})

export class StarComponent implements  OnChanges {

  @Input() category;

  star1;
  star2;
  star3;
  star4;
  star5;

  constructor() {}


  ngOnChanges() {
    if (this.category !== undefined) {
      this.star1 = false;
      this.star2 = false;
      this.star3 = false;
      this.star4 = false;
      this.star5 = false;

      switch (this.category) {
          case 1:
          this.star1 = true;
          break;
          case 2:
          this.star1 = true;
          this.star2 = true;
          break;
          case 3:
          this.star1 = true;
          this.star2 = true;
          this.star3 = true;
          break;
          case 4:
          this.star1 = true;
          this.star2 = true;
          this.star3 = true;
          this.star4 = true;
          break;
          case 5:
          this.star1 = true;
          this.star2 = true;
          this.star3 = true;
          this.star4 = true;
          this.star5 = true;
          break;
          default:
          this.star1 = false;
          this.star2 = false;
          this.star3 = false;
          this.star4 = false;
          this.star5 = false;
          break;
      }
    }else {
      this.star1 = false;
      this.star2 = false;
      this.star3 = false;
      this.star4 = false;
      this.star5 = false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared-components/star-component.ts